<template>
  <section class="section section-white" id="about">
    <div class="container text-center fade-in-section">
      <h2 class="section-title">Why We Built This</h2>
      <p class="section-subtitle max-w-3xl">From personal frustration to a solution for thousands.</p>
      
      <div class="founder-story">
        <p>After spending 10+ years in QA and software architecture, I've witnessed countless talented QA professionals struggle to advance their careers—not because they lacked skills, but because they couldn't prove them.</p>
        <p>I've seen brilliant testers passed over for promotions because their work was "invisible." I've mentored career switchers who couldn't break into QA despite having strong analytical skills. The problem isn't talent—it's the system.</p>
        <p>TestHiveQA is built to change that. We're creating a platform where your work speaks for itself, where skills are verified and portable, and where QA professionals finally get the recognition they deserve.</p>
        <div class="founder-signature">
          <p>The TestHiveQA Team</p>
          <span>Building the future of QA careers</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FounderStorySection'
}
</script>
